module.exports = __webpack_public_path__ + "createstatic/media/copy.44808a92.svg";